"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_METHOD_FILTER_TYPES = exports.ERROR_TYPE = exports.PAYMENT_TYPES = exports.PAYMENT_ACCOUNT_TYPE = exports.PAYMENT_PROCESSOR_TYPE = exports.ACCOUNT_TYPE = void 0;
var ACCOUNT_TYPE;
(function (ACCOUNT_TYPE) {
    ACCOUNT_TYPE["PAYPAL_TOKEN"] = "paypal token";
    ACCOUNT_TYPE["PLACEHOLDER"] = "PLACEHOLDER";
    ACCOUNT_TYPE["CREDIT_CARD"] = "credit card";
    ACCOUNT_TYPE["APPLE_PAY"] = "apple pay";
    ACCOUNT_TYPE["GIFT_CODE"] = "gift code";
    ACCOUNT_TYPE["BALANCE"] = "balance";
    ACCOUNT_TYPE["VENMO"] = "venmo";
    ACCOUNT_TYPE["UPI"] = "upi";
    ACCOUNT_TYPE["GOOGLE_PAY"] = "GOOGLE_PAY";
})(ACCOUNT_TYPE = exports.ACCOUNT_TYPE || (exports.ACCOUNT_TYPE = {}));
var PAYMENT_PROCESSOR_TYPE;
(function (PAYMENT_PROCESSOR_TYPE) {
    PAYMENT_PROCESSOR_TYPE["BRAINTREE"] = "BRAINTREE";
    PAYMENT_PROCESSOR_TYPE["BILLDESK"] = "BILLDESK";
})(PAYMENT_PROCESSOR_TYPE = exports.PAYMENT_PROCESSOR_TYPE || (exports.PAYMENT_PROCESSOR_TYPE = {}));
var PAYMENT_ACCOUNT_TYPE;
(function (PAYMENT_ACCOUNT_TYPE) {
    PAYMENT_ACCOUNT_TYPE["PAYPAL_TOKEN"] = "PAYPAL_TOKEN";
    PAYMENT_ACCOUNT_TYPE["CREDIT_CARD"] = "CREDIT_CARD_TOKEN";
    PAYMENT_ACCOUNT_TYPE["APPLE_PAY"] = "APPLE_PAY";
    PAYMENT_ACCOUNT_TYPE["GIFT_CODE"] = "GIFT_CODE";
    PAYMENT_ACCOUNT_TYPE["BALANCE"] = "BALANCE";
    PAYMENT_ACCOUNT_TYPE["UPI"] = "UPI";
    PAYMENT_ACCOUNT_TYPE["GOOGLE_PAY"] = "GOOGLE_PAY";
})(PAYMENT_ACCOUNT_TYPE = exports.PAYMENT_ACCOUNT_TYPE || (exports.PAYMENT_ACCOUNT_TYPE = {}));
//On the FE payment types is a combination of card type
//and account type in the case of non-credit cards
var PAYMENT_TYPES;
(function (PAYMENT_TYPES) {
    PAYMENT_TYPES["VISA"] = "visa";
    PAYMENT_TYPES["MASTERCARD"] = "mastercard";
    PAYMENT_TYPES["AMERICAN_EXPRESS"] = "amex";
    PAYMENT_TYPES["DISCOVER"] = "discover";
    PAYMENT_TYPES["JCB"] = "jcb";
    PAYMENT_TYPES["APPLE_PAY"] = "apple pay";
    PAYMENT_TYPES["ITUNES"] = "apple";
    PAYMENT_TYPES["GOOGLE_PLAY"] = "googleplay";
    PAYMENT_TYPES["PAYPAL"] = "paypal token";
    PAYMENT_TYPES["PAYPAL_TOKEN"] = "paypal token";
    PAYMENT_TYPES["GIFTCODE"] = "gift code";
    PAYMENT_TYPES["VENMO"] = "venmo";
    PAYMENT_TYPES["UPI"] = "upi";
    PAYMENT_TYPES["GOOGLE_PAY"] = "GOOGLE_PAY";
})(PAYMENT_TYPES = exports.PAYMENT_TYPES || (exports.PAYMENT_TYPES = {}));
var ERROR_TYPE;
(function (ERROR_TYPE) {
    ERROR_TYPE["FIELD"] = "field";
    ERROR_TYPE["GENERAL"] = "general";
})(ERROR_TYPE = exports.ERROR_TYPE || (exports.ERROR_TYPE = {}));
var PAYMENT_METHOD_FILTER_TYPES;
(function (PAYMENT_METHOD_FILTER_TYPES) {
    PAYMENT_METHOD_FILTER_TYPES["CREDIT_CARD"] = "credit card";
    PAYMENT_METHOD_FILTER_TYPES["PAYPAL"] = "paypal";
    PAYMENT_METHOD_FILTER_TYPES["YIFTEE"] = "yiftee";
    PAYMENT_METHOD_FILTER_TYPES["VENMO"] = "venmo";
    PAYMENT_METHOD_FILTER_TYPES["GOOGLE_PAY"] = "GOOGLE_PAY";
})(PAYMENT_METHOD_FILTER_TYPES = exports.PAYMENT_METHOD_FILTER_TYPES || (exports.PAYMENT_METHOD_FILTER_TYPES = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/methodOfPaymentAPI/constants.js
// module id = 829
// module chunks = 11